import React, { useEffect, useState, useRef } from 'react';
import './page.css';
import { MdArrowBackIosNew } from 'react-icons/md';
import { SlBadge } from 'react-icons/sl';
import { IoCopyOutline } from 'react-icons/io5';
import { CiLock } from 'react-icons/ci';
import BigImage from '../assets/building-big.jpg';
import { GetProfileDetailAPI } from '../Service/API/Get';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import { UpdateGenderAPI, UpdatePasswordAPI, UpdateProfileImageAPI } from '../Service/API/Post';
import UpdatePriceModel from '../Models/UpdatePriceModel';
import { RxCross1 } from "react-icons/rx";
import RewardsIcon from "../assets/rewards-icon.png"


export default function MyAccount() {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [selectedGender, setSelectedGender] = useState('');
  const [genderError, setGenderError] = useState('');
  const [profilePic, setProfilePic] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [updatePassword, setUpdatePassword] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: ""
  });

  const [error, setError] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: ""
  });

  const fileInputRef = useRef(null);

  const fetchUserDetails = async () => {
    try {
      const response = await GetProfileDetailAPI();
      if (response.success === true || response.status === 200) {
        setUserDetails(response?.data?.result?.data);
        setSelectedGender(response?.data?.result?.data?.gender || '')
      } else {
        // if (response.status === 401 && response.response.data === "Unauthorized") {
        //   localStorage.removeItem("user_Token");
        //   navigate("/login")
        // }
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUserDetails({});
    }
  };
  useEffect(() => {
    fetchUserDetails();
  }, []);

  const handleProfilePicChange = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('profilePic', file);
    try {
      const response = await UpdateProfileImageAPI(formData);
      if (response.status === 200) {
        fetchUserDetails();
        toast.success(response?.data?.message || "Upload profile picture successfully!")
        setProfilePic(response.data?.profilePicUrl || URL.createObjectURL(file));
      }
    } catch (error) {
      console.log("error upload image", error)
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(userDetails?.invitationCode);
    toast.success('Copied successfully!');
  };

  const handleGenderChange = (e) => {
    setSelectedGender(e.target.value);
    setGenderError('');
  };

  const handleUpdateGender = async () => {
    if (!selectedGender) {
      setGenderError('Please select a gender from the list');
    } else {
      setGenderError('');
      try {
        const response = await UpdateGenderAPI({ gender: selectedGender });
        if (response.status === 200) {
          fetchUserDetails();
          toast.success(response?.data?.message || 'Gender updated successfully!');
        }
      } catch (error) {
        console.error('Error updating gender:', error);
      }
    }
  };

  const openPopup = () => {
    setSelectedCard(true);
  };

  const closePopup = () => {
    setSelectedCard(null);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setUpdatePassword(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleUpdatePassword = async () => {
    const { oldPassword, password, confirmPassword } = updatePassword;
    const formData = {
      oldPassword,
      password,
      confirmPassword
    }
    try {
      const response = await UpdatePasswordAPI(formData);
      if (response.status === 200) {
        toast.success(response?.data?.message || 'Password updated successfully!');
        closePopup();
      } else {
        setError({
          oldPassword: response.response.data.errors.oldPassword || '',
          password: response.response.data.errors.password || '',
          confirmPassword: response.response.data.errors.confirmPassword || '',
        });
      }
    } catch (error) {
      console.error('Error updating password:', error);
    }
  }
  
  return (
    <div>
      <div className='rewards_section'>
        <div className='container'>
          <div className='rewards_heading'>
            <img src={RewardsIcon} />
            <p>Book Now & Earn Rewards</p>
          </div>
        </div>
      </div>
      <div className="Pagination_top">
        <div className="container">
          <h4 onClick={() => navigate("/")}> <MdArrowBackIosNew className="md_arrow_back" />Account Details </h4>
        </div>
      </div>
      <div className="bottom_form">
        <div className="container">
          <div className="myaccount">
            <div className="profile">
              <div className="profile_image">
                {userDetails?.profilePic || profilePic ? (
                  <img src={profilePic} 
                  alt={userDetails?.userName?.charAt(0).toUpperCase()}
                   className="profilePicPreview" />
                ) : (
                  <p className="userInitial">{userDetails?.userName?.charAt(0).toUpperCase()}</p>
                )}
              </div>
              <div className="profile_topcontent">
                <h3>richi</h3>
                <p>#{userDetails?.userId}</p>
                <input
                  type="file"
                  className="input_upload"
                  onChange={handleProfilePicChange}
                  ref={fileInputRef}
                  accept="image/*"
                />
                <button onClick={handleUploadClick}>Upload Profile Picture</button>
              </div>
            </div>
            <div className="user_details_middle">
              <p className="title_number">Phone Number</p>
              <p className="number">{`+${userDetails?.phoneCode || ''} ${userDetails?.phoneNo || ''}`}</p>
            </div>
            <div className="user_details_invitation">
              <label>Invitation code</label>
              <div className="invitation_grp">
                <input type="text" value={userDetails?.invitationCode} readOnly />
                <div className="input_icon">
                  <p onClick={handleCopyCode}><IoCopyOutline /><span>Copy Code</span></p>
                </div>
              </div>
            </div>
            <div className="user_password">
              <div className="user_details_invitation">
                <label>Password</label>
                <div className="password-inner">
                  <div className="invitation_grp">
                    <input type="password" value="2515455" readOnly />
                  </div>
                  <div className="lock_div" onClick={() => openPopup()}>
                    <p className='' > < CiLock />Change</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="user_password">
              <div className="user_details_invitation">
                <label>Gender</label>
              </div>
              <div className="password-inner">
                <div className="invitation_grp">
                  <select value={selectedGender || ''} onChange={handleGenderChange}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="update_outer">
                  <p onClick={handleUpdateGender}>Update</p>
                </div>
              </div>
              {genderError && <p className="update_profile_gender_error">{genderError}</p>}
            </div>
          </div>
        </div>
      </div>
      <div className="waiting_section">
        <div className="container">
          <div className="inner_waiting">
            <div className="waiting_images">
              <div className="left_big_image"></div>
              <div className="right_images_six"></div>
            </div>
            <div className="waiting_content"></div>
          </div>
        </div>
      </div>
      <ToastContainer />

      {isOpen && (
        <UpdatePriceModel />
      )}
      {selectedCard && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>Change Password</h2>
              <button className="close-btn" onClick={closePopup}><RxCross1 /></button>
            </div>
            <div className="popup-content">
              <div className='filed_group input_outer'>
                <label className="password">Old Password</label>
                <input
                  type="password"
                  name="oldPassword"
                  value={updatePassword.oldPassword}
                  onChange={handlePasswordChange}
                />
                {error.oldPassword && <p className="error-message">{error.oldPassword}</p>}
              </div>
              <div className='filed_group input_outer'>
                <label className="password">New Password</label>
                <input
                  type="password"
                  name="password"
                  value={updatePassword.password}
                  onChange={handlePasswordChange}
                />
                {error.password && <p className="error-message">{error.password}</p>}
              </div>
              <div className='filed_group input_outer'>
                <label className="password">Confirm New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={updatePassword.confirmPassword}
                  onChange={handlePasswordChange}
                />
                {error.confirmPassword && <p className="error-message">{error.confirmPassword}</p>}
              </div>
              <button className="popup_submit_btn" onClick={handleUpdatePassword}>Submit</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
